// https://github.com/giantcz/gia
// Add import to js/components
import Component from 'gia/Component'

export default class BannerComponent extends Component {

  constructor(element) {
    super(element);
    this.ref = {
      
      link: null,
      dismiss: null,

    }

    this.settings = this.getInitialProps();
  }

  mount() { 
    if(this.settings.position == 'fixed_top')
    document.body.classList.add('banner-active');
    document.documentElement.style.setProperty('--banner-height', this.element.offsetHeight+'px');

    const dismissed = this.getWithExpiry( 'bh-banner-dismissed' );
    if(dismissed){
      this.element.classList.add('hidden');
      document.body.classList.remove('banner-active');
    }
    if(!dismissed){
      if(this.ref.link){
        this.ref.link.addEventListener('click', this.closeBanner);
      }
      this.ref.dismiss.addEventListener('click', this.closeBanner);
    }


  }

  getInitialProps() {
    let data = {}
    try {
      data = JSON.parse(document.querySelector('script[type="application/json"]', this).innerText)
    }
    catch (e) {}
    return data
  }

  closeBanner = () => {
    document.getElementById('swup').classList.add('bh-banner--close');
    this.setWithExpiry( 'bh-banner-dismissed', 'true', this.settings.expiration );
    document.body.classList.remove('banner-active');

  }

  daysToMilliseconds(days) {
    return days*1000*60*60*24;
  }

  setWithExpiry( key, value, ttl ) {
    const now = new Date()
    const item = {
      value: value,
      expiry: now.getTime() + this.daysToMilliseconds(ttl),
    }
    localStorage.setItem(key, JSON.stringify(item),)
  }

  getWithExpiry(key) {
    const itemStr = localStorage.getItem(key)
    // if the item doesn't exist, return null
    if (!itemStr) {
      return null
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
    console.log('now', now.getTime());
    console.log('expiry', item.expiry);
    // compare the expiry time of the item with the current time
    if (now.getTime() > item.expiry) {
      // If the item is expired, delete the item from storage
      // and return null
      localStorage.removeItem(key)
      return null
    }
    return item.value
  }
  
}
